exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".file{margin-bottom:5px}.file img{width:80%}.filename-wrapper{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@media screen and (max-width:767px){.file img{width:60px;height:60px}}.img-col{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/upload-file.vue
// module id = 60
// module chunks = 0